import React from "react";
import { useRecordContext } from "react-admin";
import { HOST_LOG_ACTION_LABELS } from "./hostLogFields";

export const ActionTypeField = (props) => {
  const record = useRecordContext();
  if (!record) return null;
  const label = HOST_LOG_ACTION_LABELS[record[props.source]];
  return <span>{label || record[props.source]}</span>;
};
